import { environment } from '../config/environment';
import { type AdminApi, createAdminApi } from './admin';
import { type CustomModelsApi, createCustomModelsApi } from './custom-models';
import {
  createEmailAccountsApi,
  type EmailAccountsApi,
} from './email-accounts';
import { createFeatureFlagsApi, type FeatureFlagsApi } from './feature-flags';
import { createHttpClient } from './http';
import {
  createInstalledPackagesApi,
  type InstalledPackagesApi,
} from './installed-packages';
import {
  createKlardatenCredentialsApi,
  type KlardatenCredentialsApi,
} from './klardaten-credentials';
import { createMcpServersApi, type McpServersApi } from './mcp-servers';
import {
  createRuntimeValuesApi,
  type RuntimeValuesApi,
} from './runtime-values';
import { createTasksApi, type TasksApi } from './tasks';
import { createUsageApi, type UsageApi } from './usage';
import {
  createWorkflowAgentApi,
  type WorkflowAgentApi,
} from './workflow-agent';
import {
  createWorkflowAuditsApi,
  type WorkflowAuditsApi,
} from './workflow-audits';
import { createWorkflowsApi, type WorkflowApi } from './workflows';

export interface CreateApiOptions {
  baseUrl: string;
  headers?: Record<string, string>;
}

export interface ApiClients {
  workflows: WorkflowApi;
  workflowAudits: WorkflowAuditsApi;
  tasks: TasksApi;
  runtimeValues: RuntimeValuesApi;
  emailAccounts: EmailAccountsApi;
  installedPackages: InstalledPackagesApi;
  featureFlags: FeatureFlagsApi;
  admin: AdminApi;
  klardatenCredentials: KlardatenCredentialsApi;
  usage: UsageApi;
  customModels: CustomModelsApi;
  mcpServers: McpServersApi;
  workflowAgent: WorkflowAgentApi;
}

export function createApi({ baseUrl, headers }: CreateApiOptions): ApiClients {
  const http = createHttpClient({ baseUrl, headers });
  return {
    workflows: createWorkflowsApi(http),
    workflowAudits: createWorkflowAuditsApi(http),
    tasks: createTasksApi(http),
    runtimeValues: createRuntimeValuesApi(http),
    emailAccounts: createEmailAccountsApi(http),
    installedPackages: createInstalledPackagesApi(http),
    featureFlags: createFeatureFlagsApi(http),
    admin: createAdminApi(http),
    klardatenCredentials: createKlardatenCredentialsApi(http),
    usage: createUsageApi(http),
    customModels: createCustomModelsApi(http),
    mcpServers: createMcpServersApi(http, baseUrl),
    workflowAgent: createWorkflowAgentApi(http, baseUrl),
  };
}

export const api = createApi({ baseUrl: environment.apiBaseUrl });
